import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from 'react-router-dom'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function IntentsAns(props) {
    const [IntentList, setIntentList] = useState([])
    const [modal, setModal] = useState(false);
    const [formData, setName] = useState({ intents: "", IntDesc: "", Ans1: "", Ans2: "" });
    const [formData2, setName2] = useState({ intents: "", Ans1: "", Ans2: "" });
    const [Emotion, setEmotion] = React.useState('');
    const [EType, setType] = React.useState('');
    const [value, setValue] = useState()
    const navigate = useHistory();
    const [PortalList, setPortalList] = useState([])
    const [PoralId, setPortalId] = React.useState('');

    let pram

    useEffect(() => {
        LoadPortals();
        LoadIntents(PoralId);
    }, [PoralId])

    const LoadIntents = (portalId) => {
        //console.log("hellow portal", portalId)

        const datavalue = {
            PotId: portalId
        }

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/GetAllMasterIntentByPortalId`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            .then(res => {
                //console.log("list", res.data)
                setIntentList(res.data)

            })
    }
    // const LoadIntents = () => {
    //     let formDataSet = new FormData();
    //     formDataSet.append('id', "0");
    //     formDataSet.append('key', "Master");
    //     // key: "Not"

    //     var authOptions = {
    //         method: "post",
    //         url: `${process.env.REACT_APP_API_URL}/getIntentsByPid`,
    //         data: formDataSet,
    //         headers: { 'Content-Type': 'multipart/form-data' },
    //     };
    //     axios(authOptions)
    //         .then(res => {
    //             //console.log("list", res.data[0].intents)
    //             setIntentList(res.data)
    //         })
    // }
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`)
            .then(res => {
                //console.log("list", res.data)
                setPortalList(res.data)
            })
    }



    const IntentSubmit = async (e) => {
        e.preventDefault();

        //console.log("formData", formData)
        //console.log("dropdown", Emotion, EType)

        let formDataSet = new FormData();    //formdata object

        if (formData.intents === "" ||formData.intents == null || formData.Ans1 === "" || formData.Ans1 == null || formData.Ans2 == null || formData.Ans2 === "" || PoralId == "" || Emotion == "") {
            if (formData.intents === "" ||formData.intents == null) {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });

            } else if (formData.Ans1 === "" || formData.Ans1 == null) {
                Swal.fire({
                    title: "Error",
                    text: "Answer1 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (PoralId === "") {
                Swal.fire({
                    title: "Error",
                    text: "Please Select Portal",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            } else if (Emotion === "") {
                Swal.fire({
                    title: "Error",
                    text: "Emotion Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
                // } else if ( formData.Ans1 == null) {
                //     Swal.fire({
                //         title: "Error",
                //         text: "Cought",
                //         icon: "error",
                //         confirmButtonText: "Ok",
                //     });

            } else {
                Swal.fire({
                    title: "Error",
                    text: "Answer2 Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }


        } else {

            formDataSet.append('Intents', formData.intents);   //append the values with key, value pair
            formDataSet.append('Intent_Desc', formData.IntDesc == null || formData.IntDesc == "" ? "custom" : formData.IntDesc);
            formDataSet.append('Responce1', formData.Ans1 == null || formData.Ans1 == "" ? "0" : formData.Ans1);
            formDataSet.append('Responce2', formData.Ans2 == null || formData.Ans2 == "" ? "0" : formData.Ans2);
            formDataSet.append('Emotion', Emotion == "" ? "Neural" : Emotion);
            formDataSet.append('Emo_Type', "All");
            formDataSet.append('Id', value);
            formDataSet.append('Portal_Id', PoralId);

            //console.log("all", formData.Ans1)
            // const config = {

            //     headers: { 'content-type': 'multipart/form-data' }
            // }
            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/AddIntents`,
                data: formDataSet,
                headers: { 'Content-Type': 'multipart/form-data' },
            };
            axios(authOptions)

                .then(res => {
                    //console.log("get value", res);

                    //console.log("success", res.data.SuccessResult)
                    if (res.data.SuccessResult === "alredy") {
                        Swal.fire({
                            title: "Error",
                            text: "Question Already inserted",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    } else {
                        setName({ intents: "", Ans1: "", Ans2: "" });
                        Swal.fire({
                            title: "Success",
                            text: "Question and Answer Added Successfully",
                            icon: "success",
                            confirmButtonText: "Ok",
                        }).then(function () {
                            // window.location.pathname = "/IntentAns";
                        });
                    }

                })
                .catch(error => {
                    //console.log("error occur", error);
                })

        }
    }

    const toggle2 = () => setModal(!modal);

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    const handleChangeDrp = (event) => {

        setEmotion(event.target.value);
        //console.log("selected emo", event.target.value)

    };
    const handleChangePortal = (event) => {

        setName({ Ans1: "", Ans2: "" });

        setPortalId(event.target.value);
        //console.log("selected Portal", event.target.value)
        LoadIntents(event.target.value);

    };
    const handleChangeDrop = (event) => {

        let formDataSet = new FormData();
        setName({ intents: event.target.value })
        formDataSet.append('id', event.target.value);
        setValue(event.target.value)

        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getIntentsByid`,
            data: formDataSet,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        // axios(authOptions)
        //     .then(res => {
        //         //console.log("Intents list", res.data.result[0].Intents)
        //         setType(res.data.result[0].Intents);
        //     })

        // setType(event.target.value);
        //console.log("selectedemo", event.target.value)

    };
    const handleChangeType = (event) => {

        setType(event.target.value);
        //console.log("selectedemo", event.target.value)

    };
    const BackFunc = () => {
        navigate.push('/index')
    }

    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Create Question and Answer</div>
                            </div>
                            <div className=" pull-right">
                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Question and Answer</header>

                                </div>
                                <div className="card-body " id="bar-parent">
                                    <form className="register-form" id="login-form" onSubmit={IntentSubmit}>
                                        <div className="form-group">
                                            <div className="row">
                                                <div className='col-12 col-md-6'>
                                                    <label for="horizontalFormEmail" className="control-label">Intent</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                                    <select className="form-control select2" onChange={handleChangeDrop}>
                                                        <option value="" >--Select--</option>
                                                        {
                                                            IntentList.map((result, i) => {
                                                                return (
                                                                    <option value={result.intents} key={result.id}>{result.intents}</option>
                                                                )


                                                            })

                                                        }
                                                    </select>

                                                </div>

                                                <div className='col-12 col-md-6'>
                                                    <label for="horizontalFormEmail" className="control-label">Question Text</label>
                                                    <input type="text"
                                                        value={formData.IntDesc}
                                                        onChange={handleChange}
                                                        name="IntDesc" className="form-control" id="ans1"
                                                        placeholder="Question Text" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label for="horizontalFormEmail" className="control-label">Answer 1</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans1}
                                                onChange={handleChange}
                                                name="Ans1" className="form-control" id="ans1"
                                                placeholder="Answer 1" />
                                        </div>
                                        <div className="form-group">
                                            <label for="horizontalFormEmail" className="control-label">Answer 2</label><i className="fa fa-asterisk" style={{ fontSize: "10px", color: "red", padding: "4px" }} />
                                            <textarea type="text"
                                                value={formData.Ans2}
                                                onChange={handleChange}
                                                name="Ans2" className="form-control" id="ans2"
                                                placeholder="Answer 2" />
                                        </div>

                                        <div className="form-group">
                                            {/* <div className="card-body " id="bar-parent10"> */}
                                            <div className="form-group row">
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-lg-3 col-md-4 control-label">Emotion
                                                    </label>
                                                    <select className="form-control  select2" value={Emotion} onChange={handleChangeDrp}>
                                                        <option value="">Select Emotion</option>
                                                        <option value="Sad">Sad</option>
                                                        <option value="Angry">Angry</option>
                                                        <option value="Happy">Happy</option>
                                                        <option value="Neural">Neutral</option>

                                                    </select>
                                                </div>
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-lg-3 col-md-4 control-label">Portal
                                                    </label>
                                                    <select className="form-control select2" onChange={handleChangePortal}>
                                                        <option value="" >--Select--</option>
                                                        {
                                                            PortalList.map((result, i) => {
                                                                return (
                                                                    <option value={result.id} key={result.id}>{result.portal_Name}</option>
                                                                )
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-4 col-sm-4">
                                                    <label className="col-lg-3 col-md-4 control-label">Type
                                                    </label>
                                                    <select className="form-control  select2" value={EType} onChange={handleChangeType}>

                                                        <option value="All">All</option>


                                                    </select>
                                                </div>
                                            </div>
                                            {/* </div> */}
                                        </div>

                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default IntentsAns;